"use client";

import type { UiState } from "instantsearch.js";
import { scrubQueryClient } from "./clientPiiScrub";

interface InstantSearchInstance {
  setUiState: (state: UiState | ((previousUiState: UiState) => UiState)) => void;
}

interface MiddlewareArgs {
  instantSearchInstance: InstantSearchInstance;
}

interface PiiScrubMiddleware {
  $$type: string;
  onStateChange(args: { uiState: UiState }): void;
  subscribe(): void;
  unsubscribe(): void;
  started(): void;
}

function scrubUiState(uiState: UiState): { next: UiState; dirty: boolean } {
  let dirty = false;
  const next: UiState = { ...uiState };
  for (const indexName of Object.keys(uiState)) {
    const indexState = next[indexName];
    if (!indexState || typeof indexState.query !== "string") continue;
    const scrubbed = scrubQueryClient(indexState.query);
    if (scrubbed === indexState.query) continue;
    next[indexName] = { ...indexState, query: scrubbed };
    dirty = true;
  }
  return { next, dirty };
}

export function createPiiScrubMiddleware(): (args: MiddlewareArgs) => PiiScrubMiddleware {
  return ({ instantSearchInstance }) => ({
    $$type: "sg.piiScrub",
    onStateChange({ uiState }) {
      const { next, dirty } = scrubUiState(uiState);
      if (dirty) instantSearchInstance.setUiState(next);
    },
    subscribe() {},
    unsubscribe() {},
    started() {},
  });
}
